import { cx } from '../../cx'
import styles from './rich-text.module.css'

type Props = {
  text: string | TrustedHTML
  className?: string
}

export function RichText({ text, className }: Props) {
  return (
    <div
      className={cx(styles.richtext, 'font-body-copy', className)}
      dangerouslySetInnerHTML={{ __html: text }}
    />
  )
}
